var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.496094 7C0.496094 5.34315 1.83924 4 3.49609 4H5.99609V3.75C5.99609 2.23122 7.22729 1 8.74609 1C10.2649 1 11.4961 2.23122 11.4961 3.75V4H13.9961C15.653 4 16.9961 5.34315 16.9961 7V8.5H16.7461C15.2273 8.5 13.9961 9.7312 13.9961 11.25C13.9961 12.7688 15.2273 14 16.7461 14H16.9961V15.5C16.9961 17.1569 15.653 18.5 13.9961 18.5H3.49609C1.83924 18.5 0.496094 17.1569 0.496094 15.5V7Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.f89662606b076ae3b3a5ec550685164c.svg";
export { ForwardRef as ReactComponent };